import * as React from 'react';
import { connect } from 'react-redux';

import StatisticsAudienceOverlap from 'modules/statistics/components/StatisticsAudienceOverlap';

import { getOverlapPieChartData } from 'utils/charts/pie-chart';

import type { StatisticsCommon } from 'types';

type StateProps = {
  overlap: Array<StatisticsCommon>
};

type OwnProps = {};
type Props = StateProps & OwnProps;

const StateStatisticsOverlap = (
  {
    overlap
  }: Props
): JSX.Element => <StatisticsAudienceOverlap
  data={getOverlapPieChartData(overlap)}
/>;

const mapStateToProps = ({ statisticsAudienceOverlap }): StateProps => ({
  overlap: statisticsAudienceOverlap.overlap
});

export default connect(mapStateToProps)(StateStatisticsOverlap);
